import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { CartFunnelRadioOptionBlockConfig } from '@front-platform/content-builder';
import { cartFunnelRadioOptionBlockResolveConfig } from '@front-platform/content-builder';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Component, OnDestroy, OnInit, input } from '@angular/core';

import { CartFunnelStoreSelector } from '@common/selectors/cart-funnel.selector';
import { CartFunnelStoreDispatcher } from '@common/dispatchers/cart-funnel.dispatcher';
export interface CartFunnelRadioOptionBlockRuntimeConfig {
  'parent_id'?: string;
}

export type CartFunnelRadioOptionBlockConfigInput = Partial<
  Omit<CartFunnelRadioOptionBlockConfig, keyof CartFunnelRadioOptionBlockRuntimeConfig> &
    CartFunnelRadioOptionBlockRuntimeConfig
>;
export type CartFunnelRadioOptionBlockResolvedConfig = Omit<
  CartFunnelRadioOptionBlockConfig,
  keyof CartFunnelRadioOptionBlockRuntimeConfig
> &
  Partial<CartFunnelRadioOptionBlockRuntimeConfig>;
export interface CartFunnelRadioOptionBlockContract extends ConfigComponentContract<
  CartFunnelRadioOptionBlockConfigInput,
  CartFunnelRadioOptionBlockResolvedConfig
> {}

@Component({
  selector: 'app-cart-funnel-radio-option-block',
  templateUrl: './cart-funnel-radio-option-block.component.html',
  standalone: false,
})
export class CartFunnelRadioOptionBlockComponent
  implements OnInit, OnDestroy, CartFunnelRadioOptionBlockContract
{
  readonly config = input<CartFunnelRadioOptionBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    CartFunnelRadioOptionBlockConfig,
    CartFunnelRadioOptionBlockRuntimeConfig
  >(cartFunnelRadioOptionBlockResolveConfig, () => ({ config: this.config() }));
  private _destroyerRef = new Subject<boolean>();

  get label(): string {
    return this.resolvedConfig()['label'] as unknown as string;
  }
  get value(): string {
    return this.resolvedConfig()['value'] as unknown as string;
  }
  get parentId(): string {
    return this.resolvedConfig()['parent_id'] as unknown as string;
  }

  isActive = false;

  constructor(
    private cartFunnelSelector: CartFunnelStoreSelector,
    private cartFunnelDispatcher: CartFunnelStoreDispatcher,
  ) {}

  ngOnInit(): void {
    this.cartFunnelSelector
      .selectValue(this.parentId)
      .pipe(
        takeUntil(this._destroyerRef),
        map(input => input?.value === this.value),
      )
      .subscribe(_isActive => {
        this.isActive = _isActive;
      });
  }

  ngOnDestroy(): void {
    this._destroyerRef.next(true);
    this._destroyerRef.complete();
  }

  onValueChange(_value: boolean | string): void {
    this.cartFunnelDispatcher.updateValue({
      id: this.parentId,
      changes: {
        value: _value,
      },
    });
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(CartFunnelRadioOptionBlockComponent, {
  'keyAliases': {},
});
